import React, { useState } from 'react';
import clsx from 'clsx';

const Liana = () => {
    const [inputValue, setInputValue] = useState('');

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    };

    const handleGoClick = () => {
        console.log('Input Value:', inputValue);
    };

    return (
        <section className="home">
            <div className="container" style={{ position: 'relative', padding: 100 }}>
                <h1 className="liana-text big mt-5 has-text-centered">
                    L<span className='liana-i'>i</span><span className='liana-a'>A</span>na.
                </h1>

                <div className="field has-addons has-addons-centered pr-2 pl-2">
                    <div className="control is-expanded">
                        <input
                            className="input is-large radius-20"
                            type="text"
                            value={inputValue}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className="control">
                        <button
                            className="button is-large is-info radius-20 ml-4"
                            onClick={handleGoClick}
                        >
                            Go
                        </button>
                    </div>
                </div>

                <div className="columns is-centered">
                    <div className="column has-text-centered">
                        <p>Sales Manager</p>
                    </div>
                    <div className="column has-text-centered">
                        <p>Responsable RH</p>
                    </div>
                    <div className="column has-text-centered">
                        <p>Développeur Web</p>
                    </div>
                </div>

                <p className="subtitle is-5 has-text-centered is-max-width-10 m-0-auto pb-5">
                    LiAna vous trouve les soft skills en fonction du métier pour lequel vous recrutez.
                </p>

                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(55, 55, 55, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    fontSize: '1.5em',
                    fontWeight: 'bold',
                    borderRadius: '15px',
                    borderWidth: 4,
                    borderStyle: 'dashed',
                    zIndex: 1000,
                }}>
                    <span style={{ transform: 'rotate(25deg)', fontSize: 22, color: '#919191' }}>Cette fonctionnalité arrive bientôt !</span>
                </div>

            </div>
        </section>
    );
};

export default Liana;